/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  fetchServices,
  setSelectedService,
  submitLoanApplication,
  clearSubmitStatus,
  fetchCustomerByUserId,
  clearCustomer,
} from "../redux/slices/loan/ApplyLoanSlice";
import "../assets/Loan/PersonalLoanForm.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";

export default function PersonalLoanForm() {
  const dispatch = useDispatch();
  const {
    services,
    selectedService,
    loading,
    error,
    submitStatus,
    customer,
    loanResponse,
  } = useSelector((state) => state.applyLoan);
  const { profile } = useSelector((state) => state.userProfile);

  console.log("cusotmer", customer);

  // -------------------- States --------------------
  const [loanType, setLoanType] = useState("");
  const [loanScheme, setLoanScheme] = useState("");
  const [availableSchemes, setAvailableSchemes] = useState([]);
  const [loanAmount, setLoanAmount] = useState("");
  const [totalLoanAmount, setTotalLoanAmount] = useState("");
  const [loanTenure, setLoanTenure] = useState("");
  const [loanEMIAmount, setLoanEMIAmount] = useState(0);
  const [loanInterest, setLoanInterest] = useState(0);
  const [loanPayable, setLoanPayable] = useState(0);
  const [fees, setFees] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [formData, setFormData] = useState({
    fixedLoanFrequency: "",
    loanDisbursalMode: "",
    loanAppliedDate: "",
    loanPurpose: "",
    collectionLandmark: "",
    approvalDate: "",
    disbursalDate: "",
    status: "Pending",
    kycStatus: "Verified",
    fullName: "",
    branchCode: "BR001",
    mobileNumber: "",
    aadhaarNumber: "",
    panNumber: "",
    guarantorName: "",
    guarantorMobile: "",
    guarantorAadhaar: "",
    guarantorPAN: "",
    guarantorRelation: "",
    guarantorImageFile: null,
  });

  // -------------------- Fetch profile & services --------------------
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile?.superAdminId) {
      dispatch(fetchServices(String(profile.superAdminId)));
    }
  }, [dispatch, profile]);

  // -------------------- Prefill customer data --------------------
  useEffect(() => {
    if (selectedCustomer) {
      setFormData((prev) => ({
        ...prev,
        fullName: selectedCustomer.fullName || "",
        mobileNumber: selectedCustomer.mobileNumber || "",
        aadhaarNumber: selectedCustomer.aadhaarNumber || "",
        panNumber: selectedCustomer.panNumber || "",
        bankAccountNumber: selectedCustomer.bankAccount || "",
        ifsc: selectedCustomer.bankIFSC || "",
        guardianName: selectedCustomer.guardianName || "",
        address: selectedCustomer.address || "",
      }));
    } else if (!formData.userId) {
      setFormData({
        userId: "",
        fullName: "",
        mobileNumber: "",
        aadhaarNumber: "",
        panNumber: "",
        bankAccountNumber: "",
        ifsc: "",
        guardianName: "",
        address: "",
      });
    }
  }, [selectedCustomer, formData.userId]);

  const fetchCustomers = async () => {
    try {
      const res = await axios.get(`https://payyug.in/api/customers`, {
        params: {
          branchId: profile.id || 8,
          // superAdminId: profile.superAdminId || 14,
          page: 1,
          limit: 1000,
        },
      });
      setCustomers(res.data.data || []);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to fetch customers");
    }
  };

  useEffect(() => {
    if (profile) fetchCustomers();
  }, [profile]);

  const handleUserIdChange = (e) => {
    const userId = e.target.value;
    setFormData((prev) => ({ ...prev, userId }));
    if (userId.length >= 5) {
      dispatch(fetchCustomerByUserId(userId));
    } else {
      dispatch(clearCustomer());
    }
  };

  const handleNonZeroInput = (value, setter) => {
    const val = Number(value);
    if (val > 0) setter(val);
    else setter("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const normalizeLoanType = (type) => {
    if (!type) return "";
    const t = type.toLowerCase();
    if (t.includes("fixed")) return "Fixed";
    if (t.includes("personal")) return "Personal";
    return type;
  };

  // -------------------- Loan Schemes --------------------
  useEffect(() => {
    if (loanType) {
      const filtered = services.filter(
        (s) => s.serviceType === loanType && s.schemeStatus.toLowerCase() === "active",
      );
      setAvailableSchemes(filtered);
    } else {
      setAvailableSchemes([]);
    }
    setLoanScheme("");
  }, [loanType, services]);

  useEffect(() => {
    if (loanScheme) dispatch(setSelectedService(loanScheme));
    else dispatch(setSelectedService(null));
  }, [loanScheme, dispatch]);

  useEffect(() => {
    const fetchFees = async () => {
      try {
        if (!profile?.superAdminId || !selectedService?.id) return;

        console.log("API Calling with service:", selectedService.id);

        const res = await fetch(
          `https://payyug.in/api/all-fee-master?superadminId=${profile.superAdminId}&applicableOn=Disbursal&service=${selectedService.id}`,
        );

        const data = await res.json();
        console.log("fees response", data);

        if (data.success) {
          setFees(data.data || []);
        }
      } catch (error) {
        console.error("Error fetching fees:", error);
      }
    };

    fetchFees();
  }, [profile?.superAdminId, selectedService?.id]);

  useEffect(() => {
    let tempVar = 0;

    fees.forEach((fee) => {
      if (fee.type === "Percentage") {
        tempVar += (loanAmount * fee.value) / 100;
      } else if (fee.type === "Fixed") {
        tempVar += fee.value;
      }
    });

    setTotalLoanAmount(Number(loanAmount) + tempVar);
  }, [loanAmount, fees]);

  useEffect(() => {
    const isFixed = loanType.toLowerCase().includes("fixed");

    if (
      !isFixed &&
      Number(loanAmount) > 0 &&
      Number(loanTenure) > 0 &&
      selectedService?.roi
    ) {
      const principal = Number(loanAmount);
      const tenure = Number(loanTenure);
      const roi = Number(selectedService.roi); // Interest Rate %
      const roiType = selectedService.roiType?.toLowerCase() || "reducing"; // flat / reducing
      const recoveryFrequency =
        selectedService?.recoveryFrequency?.toLowerCase() || "daily"; // EMI frequency
      const roiFrequency =
        selectedService?.roiFrequency?.toLowerCase() || "monthly"; // ROI frequency

      // Mapping for frequency → periods per year
      const periodsPerYearMap = {
        daily: 365,
        weekly: 52,
        "bi-weekly": 26,
        "half-quarterly": 8,
        quarterly: 4,
        monthly: 12,
        yearly: 1,
      };
      const periodsPerYear = periodsPerYearMap[recoveryFrequency] || 12;

      // ✅ Calculate periodic rate (match EMI calculator logic)
      let periodRate = 0;
      if (roiFrequency === "yearly") {
        periodRate = roi / 100 / periodsPerYear;
      } else if (roiFrequency === "monthly") {
        switch (recoveryFrequency) {
          case "daily":
            // ✅ Simple division (same as your EMI calculator)
            periodRate = roi / 100 / 30;
            break;
          case "weekly":
            periodRate = roi / 100 / 4;
            break;
          case "bi-weekly":
            periodRate = roi / 100 / 2;
            break;
          case "half-quarterly":
            periodRate = roi / 100 / 2;
            break;
          case "quarterly":
            periodRate = ((roi / 100) * 3) / 12;
            break;
          case "monthly":
            periodRate = roi / 100;
            break;
          case "yearly":
            periodRate = (roi / 100) * 12;
            break;
          default:
            periodRate = roi / 100;
        }
      }

      let emi = 0;
      let totalInterest = 0;
      let totalPayable = 0;

      // === FLAT TYPE ===
      if (roiType === "flat") {
        totalInterest = principal * periodRate * tenure;
        totalPayable = principal + totalInterest;
        emi = totalPayable / tenure;
      }

      // === REDUCING TYPE ===
      else if (roiType === "reducing") {
        emi =
          (principal * periodRate * Math.pow(1 + periodRate, tenure)) /
          (Math.pow(1 + periodRate, tenure) - 1);
        totalPayable = emi * tenure;
        totalInterest = totalPayable - principal;
      }

      // ✅ Update values
      setLoanEMIAmount(Number(emi.toFixed(2)));
      setLoanInterest(Number(totalInterest.toFixed(2)));
      setLoanPayable(Number(totalPayable.toFixed(2)));

      // === Optional: Generate EMI Schedule for debug/display ===
      const schedule = [];
      let balance = principal;
      let currentDate = new Date();

      for (let i = 1; i <= tenure; i++) {
        const interestComponent = balance * periodRate;
        const principalComponent = emi - interestComponent;
        balance -= principalComponent;

        schedule.push({
          emiNo: i,
          emi: Number(emi.toFixed(2)),
          principal: Number(principalComponent.toFixed(2)),
          interest: Number(interestComponent.toFixed(2)),
          balance: balance > 0 ? Number(balance.toFixed(2)) : 0,
          dueDate: new Date(currentDate).toISOString().split("T")[0],
        });

        // Increment based on frequency
        switch (recoveryFrequency) {
          case "daily":
            currentDate.setDate(currentDate.getDate() + 1);
            break;
          case "weekly":
            currentDate.setDate(currentDate.getDate() + 7);
            break;
          case "bi-weekly":
            currentDate.setDate(currentDate.getDate() + 14);
            break;
          case "monthly":
            currentDate.setMonth(currentDate.getMonth() + 1);
            break;
          default:
            currentDate.setDate(currentDate.getDate() + 1);
        }
      }

      console.table(schedule);
    } else {
      setLoanEMIAmount(0);
      setLoanInterest(0);
      setLoanPayable(0);
    }
  }, [loanAmount, loanTenure, selectedService, loanType]);

  // -------------------- Submit Loan --------------------
  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !loanType ||
      !loanScheme ||
      !formData.fullName ||
      !formData.loanAppliedDate
    ) {
      toast.warn("Please fill all required fields!");
      return;
    }

    // if (
    //   !formData.guarantorName ||
    //   !formData.guarantorMobile ||
    //   !formData.guarantorAadhaar ||
    //   !formData.guarantorImageFile||
    //   !formData.guarantorPAN
    // ) {
    //   toast.error("Please fill guarantor details");
    //   return;
    // }

    const isFixed = loanType.toLowerCase().includes("fixed");
    const payload = {
      userId: localStorage.getItem("userId"),
      superAdminId: profile.superAdminId,
      userName: formData.fullName,
      loanType,
      loanService: loanScheme,
      branchCode: formData.branchCode || "BR001",
      minLoanAmount: selectedService?.minAmount || 0,
      maxLoanAmount: selectedService?.maxAmount || 0,
      loanRoi: Number(selectedService?.roi) || 0,
      loanRecoveryFrequency: selectedService?.recoveryFrequency || "",
      schemeId: selectedService?.id || 0,
      tenuretype: selectedService?.tenureType || "",
      roiferequency: selectedService?.roiFrequency || "",
      loanRoiType: selectedService?.roiType || "",
      prefix: selectedService?.prefix || "",
      loanAmount: isFixed
        ? selectedService?.fixedLoanAmount || 0
        : Number(loanAmount) || 0,
      loanTenure: isFixed
        ? selectedService?.fixedLoanTenure || 0
        : Number(loanTenure) || 0,
      loanEmiAmount: isFixed
        ? selectedService?.loanEmiAmount || 0
        : Number(loanEMIAmount) || 0,
      loanDisbursalMode: formData.loanDisbursalMode,
      loanAppliedDate: new Date(formData.loanAppliedDate)
        .toISOString()
        .split("T")[0],
      loanInterest: isFixed ? 0 : Number(loanInterest) || 0,
      loanPayable: isFixed ? 0 : Number(loanPayable) || 0,
      loanPurpose: formData.loanPurpose,
      collectionLandmark: formData.collectionLandmark,
      status: "Pending",
      kycStatus: "Verified",
      customerId: selectedCustomer?.userId || formData.userId,
      mobileNumber: formData.mobileNumber,
      aadhar: formData.aadhaarNumber,
      panNumber: formData.panNumber,
      bankAccountNumber: formData.bankAccountNumber,
      ifsc: formData.ifsc,
      guardianName: formData.guardianName,
      address: formData.address,
      guarantorName: formData.guarantorName,
      guarantorMobile: formData.guarantorMobile,
      guarantorAadhaar: formData.guarantorAadhaar,
      guarantorPAN: formData.guarantorPAN,
      guarantorRelation: formData.guarantorRelation,
    };

    console.log("Submitting loan payload:", payload);
    toast.success("Loan Apply Successfully.");
    dispatch(submitLoanApplication(payload));
  };

  useEffect(() => {
    if (submitStatus === "succeeded" && loanResponse?.data) {
      console.log("✅ Loan success, triggering nominee API...");

      const loanId =
        loanResponse.data?.id ||
        loanResponse.data?.loanId ||
        loanResponse.data?.data?.id;

      if (!loanId) {
        toast.error("Loan ID missing — cannot create nominee.");
        return;
      }

      const createNominee = async () => {
        try {
          const nomineeForm = new FormData();
          nomineeForm.append("guarantorName", formData.guarantorName);
          nomineeForm.append("guarantorMobile", formData.guarantorMobile);
          nomineeForm.append("guarantorAadhar", formData.guarantorAadhaar);
          nomineeForm.append("panNumber", formData.guarantorPAN);
          nomineeForm.append("relationApplicant", formData.guarantorRelation);
          nomineeForm.append("loanId", loanId);
          nomineeForm.append("branchId", profile?.id || null);
          nomineeForm.append("superAdminId", profile?.superAdminId || null);
          nomineeForm.append("customerId", selectedCustomer?.userId);

          if (formData.guarantorImageFile) {
            nomineeForm.append("file", formData.guarantorImageFile);
          }

          const res = await fetch("https://payyug.in/api/nominee-crated", {
            method: "POST",
            body: nomineeForm,
          });

          const data = await res.json();

          if (res.ok) {
            toast.success(
              data?.message || "Loan and Nominee submitted successfully!",
            );
            resetForm(); // 🔥 C
            dispatch(clearSubmitStatus()); // Optional - reset redux status
          } else {
            console.error(
              `❌ Nominee creation failed: ${data?.message || "Error"}`,
            );
          }
        } catch (err) {
          console.error("🚨 Error submitting nominee:", err);
          toast.error("Error submitting nominee!");
        }
      };

      createNominee();
    }
  }, [submitStatus, loanResponse, formData, profile]);

  // console.log("selected service ", selectedService);
  // -------------------- Render --------------------
  const isFixedLoan = loanType.toLowerCase().includes("fixed");

  const resetForm = () => {
    setLoanType("");
    setLoanScheme("");
    setAvailableSchemes([]);
    setLoanAmount("");
    setLoanTenure("");
    setLoanEMIAmount(0);
    setLoanInterest(0);
    setLoanPayable(0);
    setSelectedCustomer(null);
    setFormData({
      fixedLoanFrequency: "",
      loanDisbursalMode: "",
      loanAppliedDate: "",
      loanPurpose: "",
      collectionLandmark: "",
      approvalDate: "",
      disbursalDate: "",
      status: "Pending",
      kycStatus: "Verified",
      fullName: "",
      branchCode: "BR001",
      mobileNumber: "",
      aadhaarNumber: "",
      panNumber: "",
      guarantorName: "",
      guarantorMobile: "",
      guarantorAadhaar: "",
      guarantorPAN: "",
      guarantorRelation: "",
      guarantorImageFile: null,
      userId: "",
      bankAccountNumber: "",
      ifsc: "",
      guardianName: "",
      address: "",
    });
  };

  return (
    <div className="PersonalLoanForm-container">
      <h1>Loan Application Form</h1>
      {(loading || submitStatus === "loading") && (
        <div className="loader-overlay">
          <ClipLoader size={60} color="#3498db" />
        </div>
      )}

      <form className="PersonalLoanForm-form" onSubmit={handleSubmit}>
        {/* Loan Options */}
        <section className="PersonalLoanForm-section">
          <h2>Loan Options & Schemes</h2>
          <div className="PersonalLoanForm-loan-options">
            <div className="PersonalLoanForm-form-group">
              <label>Loan Type</label>
              <select
                value={loanType}
                onChange={(e) => setLoanType(e.target.value)}
                required
              >
                <option value="">Select Loan Type</option>
                {services
                  .filter((s) =>
                    s.serviceType.toLowerCase().includes("personal"),
                  )
                  .filter((service, index, self) => 
        index === self.findIndex((t) => t.serviceType === service.serviceType)
                )
                  .map((service) => (
                    <option key={service.id} value={service.serviceType}>
                      {service.serviceType}
                    </option>
                  ))}
              </select>
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>Loan Scheme</label>
              <select
                value={loanScheme}
                onChange={(e) => setLoanScheme(e.target.value)}
                disabled={!availableSchemes.length}
                required
              >
                <option value="">Select Scheme</option>
                {availableSchemes.map((s) => (
                  <option key={s.serviceName} value={s.serviceName}>
                    {s.serviceName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </section>

        {/* Loan Details */}
        <section className="PersonalLoanForm-section">
          <h2>Loan Details</h2>
          <div className="PersonalLoanForm-loan-details-grid">
            {/* Fixed Loan: show only Fixed Loan Amount & EMI */}
            <div className="PersonalLoanForm-form-group">
              <label>
                {isFixedLoan ? "Fixed Loan Amount" : "Minimum Loan Amount"}
              </label>
              <input
                type="number"
                value={
                  isFixedLoan
                    ? (selectedService?.fixedLoanAmount ?? "")
                    : (selectedService?.minAmount ?? "")
                }
                readOnly
              />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>
                {isFixedLoan ? "Fixed Loan EMI Amount" : "Maximum Loan Amount"}
              </label>
              <input
                type="number"
                value={
                  isFixedLoan
                    ? (selectedService?.fixedEmiAmount ?? "")
                    : (selectedService?.maxAmount ?? "")
                }
                readOnly
              />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>Loan Interest Rate (%)</label>
              <input
                type="number"
                value={selectedService?.roi || ""}
                readOnly
              />
            </div>

            <div className="PersonalLoanForm-form-group">
              <label>ROI Frequency</label>
              <input
                type="text"
                value={selectedService?.roiFrequency || ""}
                readOnly
              />
            </div>

            {/* Other loan properties read-only */}
            {[
              "roiType",
              "fixedLoanFrequency",
              "isFixedTenure",
              "maxTenure",
            ].map((id) => (
              <div className="PersonalLoanForm-form-group" key={id}>
                <label>
                  {
                    {
                      roiType: "ROI Type",
                      fixedLoanFrequency: "Fixed Loan Frequency",
                      isFixedTenure: "Is Fixed Tenure",
                      maxTenure: `Maximum Tenure (${selectedService?.tenureType || ""})`,
                    }[id]
                  }
                </label>
                <input
                  type="text"
                  value={
                    id === "isFixedTenure"
                      ? selectedService?.[id]
                        ? "Yes"
                        : "No"
                      : (selectedService?.[id] ?? "")
                  }
                  readOnly
                />
              </div>
            ))}

            {/* Loan Amount/Tenure inputs - hide for Fixed Loan */}
            {!isFixedLoan &&
              [
                {
                  id: "loanAmount",
                  label: "Loan Amount",
                  value: loanAmount,
                  set: setLoanAmount,
                },
                {
                  id: "loanTenure",
                  label: `Loan Tenure (${selectedService?.tenureType || ""})`,
                  value: loanTenure,
                  set: setLoanTenure,
                },
              ].map(({ id, label, value, set }) => (
                <div className="PersonalLoanForm-form-group" key={id}>
                  <label htmlFor={id}>{label}</label>
                  <input
                    type="number"
                    id={id}
                    name={id}
                    value={value}
                    min={1}
                    onChange={(e) => handleNonZeroInput(e.target.value, set)}
                  />
                </div>
              ))}

            {/* Calculated amounts: EMI, Interest, Payable - hide for Fixed Loan */}
            {!isFixedLoan &&
              [
                {
                  id: "loanEMIAmount",
                  label: "Loan EMI Amount",
                  value: loanEMIAmount,
                },
                {
                  id: "loanInterest",
                  label: "Loan Interest Amount",
                  value: loanInterest,
                },
                {
                  id: "loanPayable",
                  label: "Loan Payable Amount",
                  value: loanPayable,
                },
              ].map(({ id, label, value }) => (
                <div className="PersonalLoanForm-form-group" key={id}>
                  <label htmlFor={id}>{label}</label>
                  <input
                    type="number"
                    id={id}
                    name={id}
                    value={value}
                    readOnly
                  />
                </div>
              ))}

            {/* Selects for frequencies and modes */}
            {[
              // {
              //   id: "fixedLoanFrequency",
              //   label: "Fixed Loan Frequency",
              //   options: ["Monthly", "Quarterly", "Half-Yearly", "Yearly"],
              // },
              // {
              //   id: "loanRoiType",
              //   label: "Loan ROI Type",
              //   options: ["Fixed", "Floating"],
              // },
              {
                id: "loanDisbursalMode",
                label: "Loan Disbursal Mode",
                options: ["Bank Transfer", "Cheque", "Cash"],
              },
            ].map(({ id, label, options }) => (
              <div className="PersonalLoanForm-form-group" key={id}>
                <label htmlFor={id}>{label}</label>
                <select
                  id={id}
                  name={id}
                  value={formData[id] || ""}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select {label}
                  </option>
                  {options.map((o) => (
                    <option key={o} value={o}>
                      {o}
                    </option>
                  ))}
                </select>
              </div>
            ))}

            <div className="PersonalLoanForm-form-group">
              <label htmlFor="loanAppliedDate">Loan Applied Date</label>
              <input
                type="date"
                id="loanAppliedDate"
                name="loanAppliedDate"
                value={formData.loanAppliedDate || ""}
                onChange={handleChange}
              />
            </div>

            <div className="PersonalLoanForm-form-group ">
              <label htmlFor="loanPurpose">Loan Purpose</label>
              <input
                type="text"
                id="loanPurpose"
                name="loanPurpose"
                placeholder="Reason or description"
                value={formData.loanPurpose || ""}
                onChange={handleChange}
              />
            </div>

            {/* <div className="PersonalLoanForm-form-group full-width">
              <label htmlFor="collectionLandmark">Select Collection Landmark</label>
              <select
                id="collectionLandmark"
                name="collectionLandmark"
                value={formData.collectionLandmark || ""}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select Landmark
                </option>
                <option value="Near Bank Branch">Near Bank Branch</option>
                <option value="Community Center">Community Center</option>
                <option value="Local Shop">Local Shop</option>
                <option value="Other">Other</option>
              </select>
            </div> */}

            <div className="PersonalLoanForm-form-group ">
              <label htmlFor="collectionLandmark">Collection Landmark</label>
              <input
                type="text"
                id="collectionLandmark"
                name="collectionLandmark"
                placeholder="Enter collection landmark (e.g., Near Post Office)"
                value={formData.collectionLandmark || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </section>

        {/* User Details */}
        <section className="PersonalLoanForm-section">
          <h2>User Details</h2>
          <div className="PersonalLoanForm-form-group">
            <label>Customer ID</label>
            {/* <input
              type="text"
              name="userId"
              value={formData.userId || ""}
              onChange={handleUserIdChange}
              placeholder="Enter Customer ID"
              required
            /> */}
            <Select
              className="account-select-container"
              classNamePrefix="account-select"
              placeholder="Search by Name or A/C No..."
              options={customers.map((cus) => ({
                value: cus.id,
                label: `${cus.userId} | ${cus.fullName}`,
                customerDetail: cus,
              }))}
              value={
                selectedCustomer
                  ? {
                      value: selectedCustomer.id,
                      label: `${selectedCustomer.userId} | ${selectedCustomer.fullName}`,
                    }
                  : null
              }
              onChange={(selected) =>
                setSelectedCustomer(selected?.customerDetail)
              }
              isSearchable
            />
          </div>

          <div className="PersonalLoanForm-loan-details-grid">
            {[
              { id: "fullName", label: "Full Name" },
              { id: "mobileNumber", label: "Mobile Number" },
              { id: "aadhaarNumber", label: "Aadhaar Number" },
              { id: "panNumber", label: "PAN Number" },
              { id: "bankAccountNumber", label: "Bank Account Number" },
              { id: "ifsc", label: "IFSC" },
              { id: "guardianName", label: "Guardian Name" },
              { id: "address", label: "Address" },
            ].map(({ id, label }) => (
              <div className="PersonalLoanForm-form-group" key={id}>
                <label>{label}</label>
                <input
                  type="text"
                  name={id}
                  value={formData[id] || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [id]: e.target.value,
                    }))
                  }
                />
              </div>
            ))}
          </div>
        </section>

        {/* Guarantor */}
        <section className="PersonalLoanForm-section">
          <h2>Guarantor Details</h2>
          <div className="PersonalLoanForm-loan-details-grid">
            {[
              { id: "guarantorName", label: "Guarantor Name" },
              { id: "guarantorMobile", label: "Mobile Number" },
              { id: "guarantorAadhaar", label: "Aadhaar Number" },
              { id: "guarantorPAN", label: "PAN Number" },
              { id: "guarantorRelation", label: "Relation with Applicant" },
            ].map(({ id, label }) => (
              <div key={id} className="PersonalLoanForm-form-group">
                <label>{label}</label>
                <input
                  type="text"
                  name={id}
                  value={formData[id] || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [id]: e.target.value,
                    }))
                  }
                />
              </div>
            ))}
            <div className="PersonalLoanForm-form-group">
              <label>Guarantor Photo</label>
              <input
                type="file"
                // required
                accept="image/*"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    guarantorImageFile: e.target.files[0],
                  }))
                }
              />
            </div>
          </div>

          {formData.guarantorImageFile && (
            <img
              src={URL.createObjectURL(formData.guarantorImageFile)}
              alt="Preview"
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "10px",
                objectFit: "cover",
                marginTop: "10px",
              }}
            />
          )}
        </section>
        <div className="PersonalLoanForm-submit-wrapper">
          <button
            type="submit"
            className="PersonalLoanForm-apply-btn"
            disabled={submitStatus === "loading"}
          >
            {submitStatus === "loading" ? "Submitting..." : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
}
